module.exports = __webpack_public_path__ + "media/svg/close_icon-26fa42a4.svg";